import { Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { FontIconComponent } from '@camelot/icons';
import { TextComponent } from '@camelot/ui';

import { GridRow } from '../../../services/dto/grid-row';

@Component({
  host: { 'data-cid': 'grid-comment-row' },
  imports: [FontIconComponent, TextComponent],
  selector: '',
  styleUrl: './comment-row.component.scss',
  templateUrl: './comment-row.component.html',
})
export class GridCommentRowComponent implements ICellRendererAngularComp {
  public data: GridRow | null = null;

  agInit(params: ICellRendererParams): void {
    this.data = (params.data ?? null) as GridRow | null;
  }

  refresh(params: ICellRendererParams): boolean {
    this.data = (params.data ?? null) as GridRow | null;
    return true;
  }
}
